module.exports = __webpack_public_path__ + "static/img/refresh-2.ce266bb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/refresh-2.jpg
// module id = USvi
// module chunks = 1